import PropTypes from "prop-types";
import { connect } from "react-redux";
import { RemoteData } from "root/libs/core-libs/src";
import { selectCountrySettings } from "./selectors";

const Component = ({ children, countrySettings, errorPage }) =>
  RemoteData.case(
    {
      error: () => errorPage,
      _: () => children,
    },
    countrySettings
  );

Component.propTypes = {
  children: PropTypes.element.isRequired,
  countrySettings: PropTypes.object.isRequired,
  errorPage: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
  countrySettings: selectCountrySettings(state),
});

export default connect(mapStateToProps)(Component);
